import { render, staticRenderFns } from "./FormNewCampMail.vue?vue&type=template&id=61ab535c&scoped=true&"
import script from "./FormNewCampMail.vue?vue&type=script&lang=js&"
export * from "./FormNewCampMail.vue?vue&type=script&lang=js&"
import style0 from "./FormNewCampMail.vue?vue&type=style&index=0&id=61ab535c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ab535c",
  null
  
)

export default component.exports